import React from 'react';
import { AppRoute } from './types';
import { ROOTINE_APP_URL, ROOTINE_WEB_URL } from './config';
export const routes: AppRoute[] = [
  {
    title: 'Home',
    path: '/dashboard',
    primary: true,
    exact: true,
  },
  {
    title: 'Shop',
    path: `${ROOTINE_WEB_URL}/collections/shop-all`,
    external: true,
    primary: true,
    exact: true,
  },
  {
    title: 'Reports',
    path: '/dashboard/reports',
    primary: true,
    exact: true,
  },
  {
    title: 'Connect Data',
    path: '/dashboard/connect',
    primary: true,
    exact: true,
  },
  {
    title: 'Questionnaire',
    path: `${ROOTINE_APP_URL}/quiz`,
    primary: true,
    exact: true,
    external: true,
  },
  // Commenting out for now due to account info being handled by Shopify
  // Remove completely once migrated off Recurly
  // {
  //   title: 'Account',
  //   path: '/dashboard/account',
  //   primary: false,
  //   exact: true,
  //   external: false,
  // },
  // TODO: Create Contact Us page in Shopify
  // {
  //   title: 'Help',
  //   path: `${ROOTINE_WEB_URL}/contact-us`,
  //   primary: false,
  //   exact: true,
  //   external: true,
  // },
];
